const IconClose = ({ className = '', color = 'white', ...rest }) => (
    <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...rest}>
        <path d="M2.57007 2.62999L53 51.45" stroke={color} strokeWidth="4" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M2.57007 51.45L53 2.62999" stroke={color} strokeWidth="4" strokeMiterlimit="10" strokeLinecap="round" />
    </svg>

);

export default IconClose;